document.addEventListener("DOMContentLoaded", function () {
    // Sélectionner toutes les balises <kaching-bundle>
    const kachingBundles = document.querySelectorAll("kaching-bundle");

    if (document.querySelector("[data-product-discounts-container]") == undefined) {
        return true;
    }

    kachingBundles.forEach((bundle) => {
        console.log("Found ", kachingBundles.length, " kaching bundle(s)");
        var isInitialized = bundle.getAttribute("data-initialized");

        if (isInitialized === "true") {
            console.log("Kaching-bundle initialized [0]:", bundle);
            updateByUnit(bundle);
            unitOnChange(bundle);
            variantOnChange(bundle);
        } else {
            observerKachingMutation(bundle);
        }
    });
});

function variantOnChange(bundle) {
    const radioInputs = bundle.closest(".product-info")
    .querySelectorAll("[data-option-selector] input[type='radio']");

    // Ajouter un écouteur d'événements pour le changement
    radioInputs.forEach((input) => {
        input.addEventListener("change", () => {
            if (input.checked) {
                for (const variantId in variantsPrice.variants) {
                    if (variantsPrice.variants[variantId].title === input.value) {
                        variantsPrice.currentVariantId = parseInt(variantId); // Met à jour currentVariantId
                        break;
                    }
                }
                
                delayPromise().then(() => {
                    updateByUnit(bundle);
                });
            }
        });
    });    
}

function delayPromise() {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true);
        }, 100);
    });
}

function unitOnChange(bundle) {
    const radioInputs = bundle.querySelectorAll(".kaching-bundles__bar input[type='radio']");

    radioInputs.forEach((input) => {
        input.addEventListener("change", () => {
            if (input.checked) {
                console.log("Changement détecté : ", input.value);
                updateByUnit(bundle);
            }
        });
    });
}

function observerKachingMutation(bundle) {
    const observer = new MutationObserver((mutationsList, obs) => {
        mutationsList.forEach((mutation) => {
            // Vérifier si l'attribut data-initialized a changé
            if (mutation.type === "attributes" && mutation.attributeName === "data-initialized") {
                isInitialized = bundle.getAttribute("data-initialized");

                if (isInitialized === "true") {
                    obs.disconnect();
                    console.log("Kaching-bundle initialized [1]:", bundle);
                    updateByUnit(bundle);
                    unitOnChange(bundle);
                    variantOnChange(bundle);
                }
            }
        });
    });

    observer.observe(bundle, {
        attributes: true, // Observer les changements d'attributs
        attributeFilter: ["data-initialized"] // Surveiller uniquement cet attribut
    });
}

function getUnitInformations(bundle) {
    const bundleBars = bundle.querySelectorAll(".kaching-bundles__bar");

    let selectedIndex = -1;
    bundleBars.forEach((bar, index) => {
      if (bar.classList.contains("kaching-bundles__bar--selected")) {
        selectedIndex = index; // Stocker l'index
      }
    });

    const bundles = Array.from(bundleBars).map((bar) => {
        var unitsLabel = bar.querySelector(".kaching-bundles__bar-title");
        const reductionLabel = bar.querySelector(".kaching-bundles__bar-label");
        const reducedPriceElement = bar.querySelector(".kaching-bundles__bar-price");

        // console.log("reducedPriceElement ",reducedPriceElement);

        // Extraire les valeurs
        const units = unitsLabel ? parseInt(unitsLabel.textContent.replace(/[^0-9]/g, ""), 10) : null;
        unitsLabel = unitsLabel.textContent;
        const reduction = reductionLabel ? parseInt(reductionLabel.textContent.replace(/[^0-9]/g, ""), 10) : null;
        const reducedPrice = reducedPriceElement ? parseFloat(reducedPriceElement.textContent.replace(".", "").replace(/[€\s,]/g, "").replace(",", ".")) : null;

        return { 
            units, // Nombre d'unités (int)
            unitsLabel, // Nombre d'unités (string)
            reduction, // Pourcentage de réduction
            reducedPrice, // Prix réduit
        };
    });

    return { "currentUnitPos": selectedIndex, "bundles": bundles };
}

function updateByUnit(bundle) {
    var unitsInformations = getUnitInformations(bundle);

    /* variable variantsPrice from product-info.liquid */
    // console.log("currentProductPrice ", variantsPrice); 

    console.log("unitsInformations ", unitsInformations);

    const currentVariantId = variantsPrice.currentVariantId;
    const currentVariant = variantsPrice.variants[currentVariantId];
    const currentUnitPos = unitsInformations.currentUnitPos;
    const currentBundle = unitsInformations.bundles[currentUnitPos];

    const result = {
        variant: {
            id: currentVariantId,
            ...currentVariant
        },
        bundle: {
            pos: currentUnitPos,
            ...currentBundle
        }
    };

    console.log("Informations extraites :", result);

    const comparePrice = result.variant.compareAtPrice && result.variant.compareAtPrice > 0 
    ? result.variant.compareAtPrice 
    : result.variant.price;

    const reductionPercentage = (((comparePrice * result.bundle.units) - result.bundle.reducedPrice) / (comparePrice * result.bundle.units)) * 100;
    console.log(`Pourcentage de réduction : ${reductionPercentage.toFixed(2)}%`);

    document.querySelector("[data-product-discounts-container]").innerHTML = result.variant.title + " - " + result.bundle.unitsLabel + " : <b>-" + reductionPercentage.toFixed(0) + "%</b>";
    document.querySelector("[data-product-discounts-container]").classList.remove("product-info__discounts--hide");
}